import { atom, useRecoilValue } from 'recoil';
import { IUserAuthData } from '../services/auth';

export const UserState = atom<IUserAuthData | null>({
  key: 'UserState',
  default: null,
});

export const useWalletAddress = () => useRecoilValue(UserState)?.walletAddress;
export const useUserData = () => useRecoilValue(UserState);